import React from 'react';
import regoLogo from "../../assets/images/rego-logo.png";

// "מבית ReGo" first, as a real link to rego.co.il - the brand relationship is the
// point of this strip, not decoration.
const TrustStrip: React.FC = () => (
    <section className="lnk-aim__trust">
        <a className="lnk-aim__trust-item" href="https://rego.co.il/" target="_blank" rel="noopener noreferrer">
            <span className="lnk-aim__trust-dot"/>
            <span>מבית</span>
            <img src={regoLogo} alt="ReGo" width={25} height={16}/>
        </a>
        <div className="lnk-aim__trust-item">
            <span className="lnk-aim__trust-dot"/>
            <span>מומחי GEO ו-SEO</span>
        </div>
        <div className="lnk-aim__trust-item">
            <span className="lnk-aim__trust-dot"/>
            <span>ChatGPT · Gemini · Claude</span>
        </div>
    </section>
);

export default TrustStrip;
